import * as yup from "yup";

export const noteTemplateValidator = yup.object().shape({
  name: yup.string().required().max(150),
  content: yup.string().required(),
});
